<template>
  <div class="tool">
    <div class="item">
      <h3 class="title">1. 生成二维码</h3>
      <el-input placeholder="请输入内容" v-model="path">
        <!-- <el-select class="select" v-model="type" slot="prepend" placeholder="请选择">
          <el-option label="FB商城" value="fb"></el-option>
          <el-option label="内耳小程序" value="neier"></el-option>
          <el-option label="艺术电影" value="movie"></el-option>
        </el-select> -->
        <el-button slot="append" @click="getQRimg">生成</el-button>
      </el-input>
    </div>
    <div class="item item2">
      <h3 class="title">2. 电影院路径</h3>
      <p>首页：<a href="javascript:;">/pages/index/index</a></p>
      <p>关于：<a href="javascript:;">pages/menu3/index?index=0</a></p>
      <p>时间线：<a href="javascript:;">pages/menu/index?index=1</a></p>
      <p>专题：<a href="javascript:;">pages/menu/index?index=2</a></p>
      <p>带年份历史切片：<a href="javascript:;">pages/menu/index?index=1&year=1999</a></p>
    </div>

    <el-dialog title="二维码" :append-to-body="true" center :visible.sync="qrcodeVisible" width="400px">
      <img class="qrcode-img" :src="`data:image/jpeg;base64,${qrcodeUrl}`" style="width:300px;height:300px;display:block;margin:0 auto;">
    </el-dialog>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'tool',
  data () {
    return {
      qrcodeVisible: false,
      type: 'movie',
      path: '',
      qrcodeUrl: ''
    }
  },
  methods: {
    getQRimg () {
      request({
        url: '/ui/miniapp-code',
        method: 'post',
        data: {
          miniapp: this.type,
          path: this.path
        }
      }).then(res => {
        this.qrcodeUrl = res.data.code
        this.qrcodeVisible = true
      })
    }
  }
}
</script>
<style lang="less" scoped>
.tool {
  .select {
    width: 100px;
  }
  .item {
    width: 600px;
    margin-bottom: 40px;
    .title {
      font-size: 17px;
      color: #888888;
      line-height: 50px;
      letter-spacing: 1px;
    }
  }
  .item2 {
    p {
      color: #606266;
      margin-bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/tool/index.vue